import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { STATUS_INIT, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/status';

class CallForImpact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
    };
  }

  componentDidMount() {
    this.changeCallForImpact();
  }

  componentDidUpdate({ callForImpactStatus: prevStatus }) {
    const { match: { params: { id: newId } }, callForImpactStatus } = this.props;
    const { id } = this.state;

    if (parseInt(newId, 10) !== id) {
      this.changeCallForImpact();
    }

    if (prevStatus === STATUS_INIT && callForImpactStatus === STATUS_SUCCESS) {
      this.handleCallForImpactLoaded();
    }
  }

  loadCallForImpact() {
    const { getCallForImpact } = this.props;
    const { id } = this.state;

    getCallForImpact(id);
  }

  changeCallForImpact() {
    const { match: { params: { id } } } = this.props;

    this.setState({ id: parseInt(id, 10) }, this.loadCallForImpact);
  }

  handleCallForImpactLoaded() {
    const { callForImpact, history } = this.props;

    const {
      id,
      phase,
      zoom_meeting: introMeeting,
      zoom_meeting_conclusions: conclusionsMeeting,
      narrative_post_event: narrativePostEvent,
    } = callForImpact;

    switch (phase) {
      case 21275548:
        // Date Event - Main meeting -> Intro | Info
        history.push(`/zoom-meeting/${introMeeting}`);
        break;
      case 21275549:
        // Date Event - Think chat meeting
        history.push(`/narratives/${id}/think-chats/`);
        break;
      case 21275550:
        // Date Event - Main meeting ->  Conclusions
        history.push(`/zoom-meeting/${conclusionsMeeting}`);
        break;
      case 21275551:
        // Date Event - Speed Dating
        history.push(`/narratives/${id}/speed-dating/`);
        break;
      case 21275552:
        // POST Event
        history.push(`/narratives/${narrativePostEvent}`);
        break;
      default:
        // PRE event
        history.push(`/narratives/${id}`);
        break;
    }
  }

  render() {
    const { callForImpactStatus } = this.props;

    if (callForImpactStatus === STATUS_FAILURE) {
      throw new Error('error loading call for impact');
    }
    return null;
  }
}

CallForImpact.propTypes = {
  match: PropTypes.object.isRequired,
  getCallForImpact: PropTypes.func.isRequired,
  callForImpactStatus: PropTypes.string,
  callForImpact: PropTypes.object,
};

CallForImpact.defaultProps = {
  callForImpactStatus: null,
  callForImpact: null,
};

export default CallForImpact;



// WEBPACK FOOTER //
// ./src/routes/CallForImpact/components/index.jsx